function categoryJoiner (categoryList) {
  const categories = categoryList ? JSON.stringify(categoryList) : ''
  return categories.replace('[', '').replace(']', '')
}

export default categoryJoiner
